<script lang="ts">
  import Skeleton from '$components/ui/skeleton.svelte';
  import FilterAccordion from './filter-accordion.svelte';
  import Select from '$components/ui/select/select.svelte';

  import { t } from '$lib/i18n';
  import { FILTERS_VENDOR_PREFIX, SHOP_SUBCATEGORY_FILTER_ID } from '$lib/constants';
  import type { StoryblokSortKey } from '$lib/stores/content';

  import type { Filter } from '$gql/storefront/schemas';
  import { page } from '$app/stores';
  import { goto } from '$app/navigation';
  import { getValidNumberBetween } from '$lib/utils/number';
  import Button from '$components/ui/button.svelte';
  import { cn } from '$lib/utils';
  import { drawer } from '$lib/stores/drawer';

  export let sortkeys: StoryblokSortKey[];
  export let filters: Filter[] | undefined = undefined;
  export let loading = false;

  $: filtersInParams = filters?.filter((filter) => $page.url.searchParams.get(filter.id));
  $: filtersLength = filtersInParams?.reduce((acc, filter) => {
    return acc + $page.url.searchParams.getAll(filter.id).length;
  }, 0);

  let className: string | undefined = undefined;
  export { className as class };
</script>

<div class={cn('h-full flex flex-col', className)} {...$$restProps}>
  <div class="lg:hidden mb-4">
    <p class="text-xl font-semibold mb-3">{$t('shop.sort')}</p>
    <Select
      name="sort"
      value={getValidNumberBetween(
        Number($page.url.searchParams.get('sort')),
        0,
        sortkeys.length
      ).toString()}
      items={sortkeys.map((key, i) => ({ value: i.toString(), label: key.label }))}
      class="w-full"
    />
    <div class="mt-8 flex justify-between items-center">
      <p class="text-xl font-semibold">{$t('shop.filter')}</p>
    </div>
  </div>

  <div>
    {#if !filters || loading}
      <div class="flex flex-col">
        {#each Array(4) as _}
          <Skeleton class="rounded-sm w-full h-5 my-4" />
          <div class="flex gap-2 flex-wrap pb-4">
            {#each Array(5) as _}
              <Skeleton class="h-10 w-20 rounded-sm" />
            {/each}
          </div>
        {/each}
      </div>
    {:else}
      <!-- Hide filters from vendors and the SHOP_SUBCATEGORY_FILTER_ID filter (that has its own special place) -->
      {#each filters.filter((f) => !f.id.includes(FILTERS_VENDOR_PREFIX) && f.id !== SHOP_SUBCATEGORY_FILTER_ID) as filter (filter.id)}
        <FilterAccordion {filter} />
      {/each}
    {/if}
  </div>

  <div class="sticky bg-background -mx-4 bottom-0 mt-auto py-4 lg:hidden border-t">
    <div class="px-4 flex justify-between gap-2">
      <Button
        name="clear-all-filters"
        type="submit"
        variant="ghost"
        size="md"
        class="w-full"
        on:click={() => {
          goto($page.url.pathname);
        }}
      >
        {$t('shop.clear-all')}{filtersLength ? ` (${filtersLength})` : ''}
      </Button>
      <Button
        name="apply-filters"
        type="submit"
        variant="primary"
        size="md"
        class="w-full"
        on:click={() => drawer.close()}
      >
        {$t('shop.save')}
      </Button>
    </div>
  </div>
</div>
